import http from './default.js'

export default class WotcApplicantService {

  static async getAllProviders() {    
    const wotcProviderConfig = `${process.env.REACT_APP_WOTC_APPLICANT_SERVICE}/v2/providers`
    return await http.get(wotcProviderConfig)
  }
  
  static async getWotcClient(client_id) {    
    const wotcClientConfig = `${process.env.REACT_APP_WOTC_APPLICANT_SERVICE}/v2/clients/${client_id}/configure`
    return await http.get(wotcClientConfig)
  }

  static async saveWotcConfig(client_id, wotcConfig) {
    let updatedObject = {}
    if (wotcConfig.active) {
      if ((wotcConfig.selectedProvider === 'EH' || wotcConfig.selectedProvider === 'SYNERGI') && wotcConfig.selectedLocation) {
        updatedObject = {
          ...wotcConfig,
          locations: [
            {
              id: wotcConfig?.selectedLocation?.id,
              providerLocationId:  wotcConfig.selectedLocationId
            }
          ],
          organizationCode: wotcConfig.selectedOrganizationCode,
          providerName: wotcConfig.selectedProvider
        }
      } else if ((wotcConfig.selectedProvider === 'EH' || wotcConfig.selectedProvider === 'SYNERGI') && !wotcConfig.selectedLocation) {
        updatedObject = {
          ...wotcConfig,
          locations: [],
          organizationCode: wotcConfig.selectedOrganizationCode,
          providerName: wotcConfig.selectedProvider
        }
      } else if (wotcConfig.selectedProvider === 'ADP') {
        updatedObject = {
          ...wotcConfig,
          locations: [],
          organizationCode: wotcConfig.selectedOrganizationCode,
          providerName: wotcConfig.selectedProvider
        }
      } else {
        updatedObject = {
          ...wotcConfig,
          organizationCode: wotcConfig.selectedOrganizationCode,
          providerName: wotcConfig.selectedProvider
        }
      }
    } else {
      updatedObject = {
        ...wotcConfig
      }
    }
    
    const wotcClientConfig = `${process.env.REACT_APP_WOTC_APPLICANT_SERVICE}/v2/clients/${client_id}/configure`
    const response = await http.post(wotcClientConfig, updatedObject)
    return response
  }

  static async getAllLocations(client_id) {
    const wotcLocationsUrl = `${process.env.REACT_APP_WOTC_APPLICANT_SERVICE}/v2/locations/clients/${client_id}`
    return await http.get(wotcLocationsUrl)
  }

  static async getAllLocationsByNameFilter(client_id, name) {
    const encodedName = encodeURIComponent(name)
    const wotcLocationsUrl = `${process.env.REACT_APP_WOTC_APPLICANT_SERVICE}/v2/locations/clients/${client_id}?nameFilter=${encodedName}`
    return await http.get(wotcLocationsUrl)
  }


  static async getWotcEditHistory(client_id) {
    const clientConfig = `${process.env.REACT_APP_WOTC_APPLICANT_SERVICE}/v2/clients/${client_id}/configure/history`
    const response = await http.get(clientConfig)
    return response
  }

  static async getLocationsByLocationId(client_id, location_id) {
    const wotcLocationUrl = `${process.env.REACT_APP_WOTC_APPLICANT_SERVICE}/v2/locations/clients/${client_id}/locations/${location_id}`
    return await http.get(wotcLocationUrl)
  }
}